import(/* webpackMode: "eager" */ "C:\\Verasoft\\KORVUE-XL\\rxl\\src\\app\\page.tsx");
